<template>
    <div class="pay info">
        <div class="orderInfo">
            <h2>
                <span>{{ orderInfo.createDate | dateTime }}</span>
                <span>订单编号：{{ orderInfo.orderNo }}</span>
            </h2>
            <table>
                <tr>
                    <td>{{ orderInfo.orderName }}</td>
                    <td v-html="xq(orderInfo.orderDetail)"></td>
                    <td>
						<span class="hong">￥{{ orderInfo.realAmount}}</span>
                        <s>￥{{ orderInfo.payAmount }}</s>
                    </td>
                </tr>
            </table>
        </div>
        <div class="invoiceInfo">
            <h3>发票信息<span class="hongse">(温馨提示：需要发票的在此处添加)</span></h3>
            <p v-if="invoiceInfo">
                <span v-if="invoiceInfo.invoiceType == 1">普通发票</span>
                <span v-if="invoiceInfo.invoiceType == 2">增值税发票</span>
                <span v-if="invoiceInfo.openType == 2">个人</span>
                <span v-if="invoiceInfo.openType == 1">单位</span>
                <span v-for="item in projectList" v-if="invoiceInfo.project == item.value">{{ item.name }}</span>
                <span class="edit" @click="editLoading = true">修改</span>
            </p>
            <p v-else>
                <span class="edit" @click="editLoading = true">添加</span>
            </p>
        </div>
        <div class="payBox">
            <h3>支付方式</h3>
            <el-tabs v-model="payType" @tab-click="handleClick">
                <el-tab-pane name="1" label="微信支付">
                    <div class="weBox" v-loading="codeLoading">
                        <qriously v-if="codeUrl" :value="codeUrl" :size="180" />
                        使用微信钱包扫一扫付款
                    </div>
                </el-tab-pane>
                <el-tab-pane name="2" label="支付宝支付">
                    <div class="weBox" v-loading="codeLoading">
                        <qriously v-if="codeUrl" :value="codeUrl" :size="180" />
                        使用支付宝钱包扫一扫付款
                    </div>
                </el-tab-pane>
                <el-tab-pane name="3" label="银联支付">
                    银联支付
                    <div class="pay-qrcode" id="pay-qrcode"></div>
                    正在跳转...
                </el-tab-pane>
                <el-tab-pane name="4" label="汇款" class="remittance">
                    <p>公司名称：环亚协同（北京）风险管理技术有限公司</p>
                    <p>开户行名称：招行建国路支行</p>
                    <p>账号：110906740410802</p>
                    <p>地址：北京市朝阳区朝阳区常惠路北辰福第V中心B座1408</p>
                    <p>电话：010-85521991</p>
                    <el-form ref="enrollInfo" label-width="0" @submit.native.prevent>
                        <el-form-item prop="certUrl" class="img">
                            <upload-images
                                v-model="certUrl"
                                :limit="1"
                                string>
                                <div class="mask">
                                    <i class="el-icon-circle-plus-outline"></i>
                                    请上传凭证
                                </div>
                            </upload-images>
                            <el-button :loading="submitLoading" @click="submit(false)">立即提交</el-button>
                        </el-form-item>
                        <h6>请您上传您支付的银行转账凭条的照片，或网上银行截图，或发票照片，或收据照片。</h6>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane name="5" label="机构支付" class="mechanism">
                    <p>向CERM有效授权机构支付</p>
                    <p>1、您可以电话咨询CERM总部确认您即将打款的机构是否为CERM有效授权机构，或者微信公众号查询。（电话：010-85521991-801 微信公众号：CERO-CRO 附：二维码）</p>
                    <el-button :loading="submitLoading" @click="submit(true)">立即提交</el-button>
                </el-tab-pane>
            </el-tabs>
        </div>
        
        <el-dialog
            title="发票信息"
            :visible.sync="editLoading"
            width="500px">
            <invoice v-if="editLoading" :invoice-info-back="invoiceInfo" :select-name="orderInfo.userName" @closeDialog="editInvoice" :project-list="projectList" :order-id="orderInfo.id" />
        </el-dialog>

        
    </div>
</template>

<script>
import * as API_Order from '@/api/order'
import invoice from '@/components/invoice'
import uploadImages from '@/components/imageUpLoad'
import { orderPrePay } from '@/api/enroll'
import { listByType } from '@/api/cms'
import Vue from 'vue'
import VueQriously from 'vue-qriously'
Vue.use(VueQriously)
export default {
    name: 'pay',
    components: {
        invoice,
        uploadImages,
    },
    data(){
        return {
            payType: '',
            editLoading: false,
            submitLoading: false,
            orderInfo: {},
            invoiceInfo: '',
            certUrl: '',
            orderInterval:'',
            orderState: false,
            orderId: '',
            projectList: [],
            codeUrl: '',
            codeLoading: false,
        }
    },
    mounted(){
        this.$emit('changeIndex',6)
        this.orderId = this.$route.params.id
        API_Order.orderDetail({ id: this.orderId, count: 1 }).then(res => {
            this.orderInfo = res
        })
        orderPrePay({ id: this.orderId }).then(res => {})
        API_Order.orderInvoiceDetail({ orderId: this.orderId }).then(res => {
            if(res){
                res.project += ''
                this.invoiceInfo = res
            }
        })
        listByType('INVOICE_PROJECT').then(res => {
            if(res.length){
                this.projectList = res
            }
        })
    },
    methods:{
        xq(a){
            if(a){
                return a.replace(/，/g,'<br>')
            }
        },
        handleClick(val){
            clearInterval(this.orderInterval)
            this.codeLoading = true
            this.codeUrl = ''

            API_Order.changePayType({ id: this.orderId, payType: val.name }).then(res => {
                if(res.code == 0){
                    this.codeUrl = res.msg
                    if(val.name == 1 || val.name == 2){
                        let sum = 0
                        this.orderInterval = setInterval(() => {
                            sum ++
                            API_Order.heartBeat({ id: this.orderId }).then(res => {
                                if(res.code == 0){
                                    this.orderState = true
                                }
                            })
                            if(this.orderState){
                                clearInterval(this.orderInterval)
                                this.$message.success('支付成功')
                                this.next(1)
                            }else if(sum == 60){
                                clearInterval(this.orderInterval)
                                this.$message.error('支付超时，请刷新重试')
                                setTimeout(() => {
                                    location.reload()
                                }, 2000)
                            }
                        },2000)
                    }else if(val.name == 3){
                        document.getElementById('pay-qrcode').innerHTML = res.msg
                        document.getElementById('pay_form').submit()
                    }
                }
                this.codeLoading = false
            }).catch(res =>{
                this.codeLoading = false
                this.next(1)
            })
        },
        editInvoice(info){
            if(info){
                info.project += ''
                this.invoiceInfo = info
            }
            this.editLoading = false
        },
        submit(type){
            if(!type){
                if(this.certUrl){
                    this.submitLoading = true
                    API_Order.remitOrg({ certUrl: this.certUrl, id: this.orderId, isPay: 1 }).then(res => {
                        this.submitLoading = false
                        this.next(1)
                    }).catch(res => {
                        this.submitLoading = false
                    })
                }else{
                    this.$message.error('请上传凭证')
                }
            }else{
                this.submitLoading = true
                API_Order.remitOrg({ id: this.orderId, isPay: 1 }).then(res => {
                    this.submitLoading = false
                    this.next(1)
                }).catch(res => {
                    this.submitLoading = false
                })
            }
        },
        next(type){
            this.$router.push(`/result/${type}`)
        }
    },
    beforeDestroy(){
        clearInterval(this.orderInterval)
    }
}
</script>

<style scoped>
    @import './info.css';
	.hong{color: red;font-size: 25px;padding-right: 15px;}
    .orderInfo{border:1px solid #e4f1fc;}
    .orderInfo h2{background: #e4f1fc;line-height: 40px;color: #010101;font-size: 14px;padding: 0 18px;font-weight: 400;}
    .orderInfo h2 span{margin-right: 40px;}
    .orderInfo table{width: 100%;text-align: center;line-height: 18px;padding: 28px 0;}

    h3{font-size: 16px;color: #000000;font-weight: 600;line-height: 16px;padding-top: 20px;margin-bottom: 10px;}
    .invoiceInfo{border-top:1px solid #e6e6e6;border-bottom:1px solid #e6e6e6;margin-top: 20px;}
    .invoiceInfo p{line-height: 22px;padding-bottom: 14px;}
    .invoiceInfo p span{font-size: 14px;color: #000;margin-right: 50px;}
    .invoiceInfo p span.edit{color: #bf371e;cursor: pointer;text-decoration: underline;}
	.hongse{color: red;font-size: 12px;}
	
    .payBox >>> .el-tabs__item{width: 120px;height: 35px;border:1px solid #999999;font-size: 14px;color: #000;line-height: 33px;text-align: center;padding: 0;margin-right: 10px;}
    .payBox >>> .el-tabs__item.is-active{background: #bf371e;border-color: #bf371e;color: #fff;}
    .payBox >>> .el-tabs__header{margin-bottom: 10px;}
    .payBox >>> .el-tabs__active-bar{display: none;}
    .payBox >>> .el-tabs__nav-wrap::after{display: none;}
    .payBox >>> .el-tabs__content{padding: 30px 40px;border:1px solid #e6e6e6;}

    .weBox{width: 180px;text-align: center;}
    .weBox img{display: block;width: 100%;height: 180px;margin-bottom: 14px;}
    .weBox p{font-size: 14px;color: #010101;}

    .remittance p{font-size: 14px;color: #000000;line-height: 26px;}
    .remittance h6{width: 160px;font-size: 12px;text-align: justify;color: #666666;line-height: 15px;margin-top: -12px;}

    .remittance >>> .el-form-item__content{height: 148px;margin-top: 20px;}
    .remittance >>> .el-button{position: relative;top: -13px;}

    .mechanism p{font-size: 14px;color: #000000;line-height: 26px;width: 350px;text-align: justify;}
    .mechanism >>> .el-button{margin-top: 20px !important;}

</style>
